import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { resetPasswordSchema } from 'utils/validators/resetPassword';
import TextField from 'shared/components/text-field/TextField';
import Button from 'shared/components/button/Button';
import Loader from 'features/Loader/Loader';
import './forgetPassword.scss';
import { resetPassword } from '../../ducks/authActions';

const ForgetPassword = props => {
  let { resetPasswordEmailSent, resetPasswordError, loading } = props;

  return (
    <Formik
      onSubmit={async values => {
        return props.resetPassword(values.email);
      }}
      initialValues={{ email: '' }}
      validationSchema={resetPasswordSchema}
    >
      {({ values, isSubmitting }) => (
        <Form>
        { (isSubmitting || loading) ? (<Loader />) : (
            <div className="onboarding">
              <div className="reset-password">
                <div className="form-side">
                  <div className="shape shape-left"></div>
                  <div className="shape shape-right"></div>
                  <div className="form-content">
                    <h3>Reset Password</h3>
                    {resetPasswordEmailSent ? (
                      <>
                        <p className="verify-hint">
                          We sent a reset password link to {values.email}. Tap the
                          link in your email to reset your password.
                        </p>
                        <div className="resend-hint">
                          <p>
                            Didn’t recieve the email?{' '}
                            <Button
                              type="submit"
                              color="link"
                              customClasses="resend-btn"
                              label={`Resend${isSubmitting ? '...' : ''}`}
                            />
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <TextField
                          type="text"
                          name="email"
                          label="Email"
                          placeholder="trainer@hybridmmafit.com"
                          error={resetPasswordError}
                        />
                        <div className="form-action">
                          <Button
                            id="submit-btn"
                            type="submit"
                            btnBlock="block"
                            color="primary"
                            label="Submit"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        }
        </Form>
      )}
    </Formik>
  );
};

function mapStateToProps(state) {
  return {
    authMsg: state.authReducer.authMsg,
    resetPasswordEmailSent: state.authReducer.resetPasswordEmailSent,
    resetPasswordError: state.authReducer.resetPasswordError,
    loading: state.authReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetPassword: email => dispatch(resetPassword(email))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgetPassword);
